import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #ffffff;
  width: 4px;
  height: 13px;
`

export const WarningIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 13" className={className}>
      <path d="M0.899902 1.20001C0.899902 0.900012 0.999902 0.700012 1.3999 0.700012H2.7999C3.0999 0.700012 3.2999 0.900012 3.2999 1.20001V2.30001C3.2999 2.60001 3.0999 2.70001 2.7999 2.70001H1.3999C1.0999 2.70001 0.899902 2.60001 0.899902 2.30001V1.20001ZM0.899902 4.90001C0.899902 4.70001 0.999903 4.60001 1.1999 4.60001H2.9999C3.1999 4.60001 3.2999 4.70001 3.2999 4.90001V12C3.2999 12.2 3.1999 12.3 2.9999 12.3H1.1999C0.999903 12.3 0.899902 12.2 0.899902 12V4.90001Z" />
    </Svg>
  )
}
